import React from 'react';
import { Bell, Search, Globe, Lock, Menu, ChevronLeft, ChevronRight } from 'lucide-react';
interface HeaderProps {
  onMenuClick: () => void;
  onToggleCollapse: () => void;
  sidebarCollapsed: boolean;
}
const Header: React.FC<HeaderProps> = ({
  onMenuClick,
  onToggleCollapse,
  sidebarCollapsed
}) => {
  const currentDate = new Date().toLocaleDateString('id-ID', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
  const currentTime = new Date().toLocaleTimeString('id-ID', {
    hour: '2-digit',
    minute: '2-digit'
  });
  return <header className="h-16 bg-gradient-to-r from-[#0F1419]/95 to-[#0A0E17]/95 backdrop-blur-xl border-b border-gray-800/50 px-4 md:px-6 flex items-center justify-between shadow-lg" data-id="element-31">
      <div className="flex items-center space-x-4" data-id="element-32">
        {/* Mobile Menu Button */}
        <button onClick={onMenuClick} className="lg:hidden p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-all duration-200" data-id="element-33">
          <Menu className="h-5 w-5" data-id="element-34" />
        </button>
        {/* Desktop Collapse Button */}
        <button onClick={onToggleCollapse} className="hidden lg:flex p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-all duration-200" data-id="element-35">
          {sidebarCollapsed ? <ChevronRight className="h-5 w-5" data-id="element-36" /> : <ChevronLeft className="h-5 w-5" data-id="element-37" />}
        </button>
        {/* Date and Time */}
        <div className="hidden md:flex items-center space-x-2 text-gray-400 text-sm" data-id="element-38">
          <div className="flex items-center space-x-2 px-3 py-1.5 bg-gray-800/50 rounded-lg border border-gray-700/50" data-id="element-39">
            <span data-id="element-40">{currentDate}</span>
            <span className="text-gray-600" data-id="element-41">•</span>
            <span className="text-cyan-400 font-medium" data-id="element-42">{currentTime}</span>
          </div>
        </div>
      </div>
      {/* Right Section */}
      <div className="flex items-center space-x-2 md:space-x-3" data-id="element-43">
        {/* Status Badge */}
        <div className="flex items-center px-3 py-1.5 bg-green-900/20 rounded-lg text-xs text-green-400 border border-green-800/30 shadow-lg shadow-green-500/5" data-id="element-44">
          <Lock className="h-3 w-3 mr-1.5" data-id="element-45" />
          <span className="hidden sm:inline font-medium" data-id="element-46">SECURE</span>
        </div>
        <div className="h-6 w-px bg-gray-700/50" data-id="element-47"></div>
        {/* Action Buttons */}
        <div className="flex items-center space-x-1 md:space-x-2" data-id="element-48">
          <button className="p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-all duration-200 relative group" data-id="element-49">
            <Search className="h-5 w-5" data-id="element-50" />
            <div className="absolute inset-0 bg-cyan-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-51"></div>
          </button>
          <button className="p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-all duration-200 relative group" data-id="element-52">
            <Bell className="h-5 w-5" data-id="element-53" />
            <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full animate-pulse shadow-lg shadow-red-500/50" data-id="element-54"></span>
            <div className="absolute inset-0 bg-cyan-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-55"></div>
          </button>
          <button className="hidden sm:flex p-2 text-gray-400 hover:text-white hover:bg-gray-800/50 rounded-lg transition-all duration-200 relative group" data-id="element-56">
            <Globe className="h-5 w-5" data-id="element-57" />
            <div className="absolute inset-0 bg-cyan-500/10 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-58"></div>
          </button>
        </div>
      </div>
    </header>;
};
export default Header;